export const FETCH_REPRESENTATIVES = 'FETCH_REPRESENTATIVES';
export const FETCH_REPRESENTATIVES_ADDRESS = 'FETCH_REPRESENTATIVES_ADDRESS';
export const FETCH_USER = 'FETCH_USER';
export const FETCH_REFERENT = 'FETCH_REFERENT';
export const FETCH_SERVICES = 'FETCH_SERVICES';
export const UPLOADING_DOCUMENT = 'UPLOADING_DOCUMENT';
export const DELETING_DOCUMENT = 'DELETING_DOCUMENT';

export const ADDING_PAYMENTMETHOD = 'ADDING_PAYMENTMETHOD';
export const DELETING_PAYMENTMETHOD = 'DELETING_PAYMENTMETHOD';
export const PROCESSING_PAYMENT = 'PROCESSING_PAYMENT';

export const GETTING_SETUPINTENT = 'GETTING_SETUPINTENT';
export const UPDATING_SERVICES = 'UPDATING_SERVICES';
export const FETCH_INVOICES = 'FETCH_INVOICES';
export const UPDATE_USER = 'UPDATE_USER';
export const UPDATE_SECURITY = 'UPDATE_SECURITY';

export const AUTHENTICATING_USERREPRESENTING = 'AUTHENTICATING_USERREPRESENTING';
export const FETCHING_USER_ADDRESSES = 'FETCHING_USER_ADDRESSES';
export const UPDATING_USER_ADDRESS = 'UPDATING_USER_ADDRESS';

export const SENDING_OTP = 'SENDING_OTP';
export const VALIDATING_OTP = 'VALIDATING_OTP';
export const GETTING_BILLINGCUSTOMERID = 'GETTING_BILLINGCUSTOMERID';

export const FETCH_PARTNER_CUSTOMIZATION = "FETCH_PARTNER_CUSTOMIZATION";

export const FETCH_LIFEEVENTS = 'FETCH_LIFEEVENTS';

export const GENERATING_PRINT = "GENERATING_PRINT";

